import type { Supplier } from './types.js';

/**
 * Yayın penceresinin açık pazar ve bölge kuralları (ADR 0113 §2, §5): davetli yayında en az bir
 * davetli. Davet listesi yalnız onaylı ve etkin
 * tedarikçilerdir (sorular #79), bölge seçilince yalnız o bölgeye hizmet verenler kalır.
 */

/** Bölge süzgecinin "hepsi" seçeneği. */
export const ALL_REGIONS = 'all';

export function suppliersForPublish(
  suppliers: readonly Supplier[],
  input: { invitedIds: readonly string[]; region: string },
): Supplier[] {
  const invited = new Set(input.invitedIds);
  return suppliers.filter(
    (s) =>
      s.approved &&
      s.active &&
      !invited.has(s.id) &&
      (input.region === ALL_REGIONS || (s.serviceRegions ?? []).includes(input.region)),
  );
}

/**
 * Açık yayında teslim bölgesi isteğe bağlı bilgidir (sahip kararı 2026-10-23: açık RFQ bütün
 * tedarikçilere açık); davetli yayında şirketin tedarikçilerinden ya da partner dizininden en az bir
 * davetli olmalıdır.
 */
export function validateMarketFields(input: {
  visibility: 'open' | 'invited';
  /** RFQ'nun bugünkü davetlileri. */
  invited: number;
  /** Pencerede seçilen şirket tedarikçileri. */
  picked: number;
  /** Partner dizininden seçilenler. */
  partners: number;
}): Record<string, string> {
  if (input.visibility === 'open') return {};
  return input.invited + input.picked + input.partners > 0 ? {} : { suppliers: 'NO_SUPPLIERS' };
}
